// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentIconsBar_root__fb1Y2"};